// extracted by mini-css-extract-plugin
export var addButton = "_5z-d";
export var bullets = "_5z-e";
export var compact = "_5z-2";
export var container = "_5z-j";
export var extendedWarrantyModal = "_5z-f";
export var learn = "_5z-l";
export var learnMore = "_5z-g";
export var offeringOption = "_5z-3";
export var offeringPrice = "_5z-8";
export var offeringSubtitle = "_5z-7";
export var offeringTitle = "_5z-6";
export var offeringsContainer = "_5z-0";
export var pdpTilesBackground = "_5z-n";
export var plan = "_5z-m";
export var regular = "_5z-1";
export var remove = "_5z-k";
export var seeDetailsIcon = "_5z-i";
export var seeDetailsLink = "_5z-h";
export var selectedOption = "_5z-4";
export var shieldIcon = "_5z-b";
export var shieldIconCompact = "_5z-c";
export var subtitle = "_5z-a";
export var title = "_5z-9";
export var unselectedOption = "_5z-5";